import { render, staticRenderFns } from "./MdinList.vue?vue&type=template&id=ba9846b0&scoped=true&"
import script from "./MdinList.vue?vue&type=script&lang=js&"
export * from "./MdinList.vue?vue&type=script&lang=js&"
import style0 from "./MdinList.vue?vue&type=style&index=0&id=ba9846b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9846b0",
  null
  
)

export default component.exports